<template>
<div class="chapter">
<div class="inner_page">
<p class="noind" id="dedication">To my buddy Jacqueline Woodson</p>
<p class="noind">extraordinary writer,</p>
<p class="noind">friend,</p>
<p class="noind">role model.</p>
<p class="noind">For reminding me that</p>
<p class="noind">good intentions</p>
<p class="noind">are not</p>
<p class="noind">good enough.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-dedication.vue?63c1cf9c